export default __webpack_public_path__ + "static/media/mana17.8607aa13.svg";